import React, {ReactNode} from "react";
import {CopyDialogProvider, CopyDialogRenderer} from "../components/copy-dialog/CopyDialog";
import {FormDialogProvider, FormDialogRenderer} from "../components/form-dialog/FormDialogProvider";
import {
    EmployeeKeyHistoryDialogProvider,
    EmployeeKeyHistoryDialogRenderer,
} from "../pages/employees/EmployeeKeyHistoryDialog";
import {
    KeyHistoryDialogProvider,
    KeyHistoryDialogRenderer,
} from "../pages/manage-keys/KeyHistoryDialog";

export function DialogProvider({children}: {children: ReactNode}) {
    return (
        <CopyDialogProvider>
            <FormDialogProvider>
                <EmployeeKeyHistoryDialogProvider>
                    <KeyHistoryDialogProvider>
                        {children}
                        <CopyDialogRenderer/>
                        <FormDialogRenderer/>
                        <EmployeeKeyHistoryDialogRenderer/>
                        <KeyHistoryDialogRenderer/>
                    </KeyHistoryDialogProvider>
                </EmployeeKeyHistoryDialogProvider>
            </FormDialogProvider>
        </CopyDialogProvider>
    );
}
